__turbopack_context__.v({
  "appBadges": "FFjwhq_appBadges",
  "autoPlay": "FFjwhq_autoPlay",
  "card": "FFjwhq_card",
  "card1": "FFjwhq_card1",
  "card2": "FFjwhq_card2",
  "card3": "FFjwhq_card3",
  "cardStack": "FFjwhq_cardStack",
  "container": "FFjwhq_container",
  "ctaWrapper": "FFjwhq_ctaWrapper",
  "description": "FFjwhq_description",
  "logo": "FFjwhq_logo",
  "qrCard": "FFjwhq_qrCard",
  "textContent": "FFjwhq_textContent",
  "title": "FFjwhq_title",
});
